module.exports = __webpack_public_path__ + "img/opciones.5be7f49d.svg";